import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDatepicker,
  MatDialogRef
} from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener
} from '@angular/material/tree';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { Moment } from 'moment';
import { combineLatest, forkJoin } from 'rxjs';
import {
  EnergyService,
  PlantServiceService,
  SiteService,
  UtilitiesService
} from '../../../../services/index';
import {
  AppUtils,
  Constants,
  Highcharts$,
  Moment$
} from '../../../../shared/index';
export class AttributeClass {
  class: string;
  parentId: number;
  childClass: string;
  thisClass: string;
}
/**
 * Node for feature item
 */
export class FeatureItemNode {
  id: number;
  nodes: FeatureItemNode[];
  item: string;
  nodeType: string;
  processRId: any;
  meterId: any;
  loadId: any;
  selected: boolean;
  attributes: AttributeClass;
}

/** Flat feature item node with expandable and level information */
export class FeatureItemFlatNode {
  id: number;
  item: string;
  level: number;
  expandable: boolean;
  attributes: AttributeClass;
  nodes: FeatureItemNode[];
  nodeType: string;
  processRId: any;
  meterId: any;
  loadId: any;
}
@Component({
  selector: 'app-energy-trends',
  templateUrl: './energy-trends.component.html',
  styleUrls: ['./energy-trends.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    {
      provide: MAT_DATE_FORMATS,
      useValue: Constants.DATE_RANGES_PROVIDER_FORMAT
    }
  ]
})
export class EnergyTrendsComponent implements OnInit, AfterViewInit {
  siteId: string;
  shifts: any;
  timebaseArr = Constants.TIMEBASE_ARRAY;
  timebase = 'D';
  columnchart: Chart;
  startDate = new FormControl(Moment$());
  endDate = new FormControl(Moment$());
  enableShiftwise = false;
  showidleEnergy = false;
  startView = 'month';
  minView = 'day';
  hourWiseDataRequired = false;
  currentNode: {
    nodeData: any;
    meterIds: any;
    nodeTitle: string;
    nodeType: string;
  } = Object.assign({});
  /* Property for Tree*/
  /** The selection for checklist */
  checklistSelection = new SelectionModel<FeatureItemFlatNode>(false /* mul */);
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<FeatureItemFlatNode, FeatureItemNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<FeatureItemNode, FeatureItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: FeatureItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<FeatureItemFlatNode>;

  treeFlattener: MatTreeFlattener<FeatureItemNode, FeatureItemFlatNode>;

  dataSource: MatTreeFlatDataSource<FeatureItemNode, FeatureItemFlatNode>;
  // organizationDataSource = new MatTableDataSource<OrganizationModel>();
  selectedNode: FeatureItemFlatNode;
  max = new Date();
  //
  parentOfFirstLeaf: any;
  //
  isValidStartDate = true;
  startDateErrorMessage: String;
  isValidEndDate = true;
  endDateErrorMessage: String;
  thousandSeparator: string;
  decimalSepartor: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private activeRoute: ActivatedRoute,
    private plantService: PlantServiceService,
    private datePipe: DatePipe,
    private router: Router,
    private siteService: SiteService,
    private energyService: EnergyService,
    private utilitiesService: UtilitiesService,
    private dialogRef: MatDialogRef<EnergyTrendsComponent>
  ) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<FeatureItemFlatNode>(
      this.getLevel,
      this.isExpandable
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
    this.thousandSeparator = AppUtils.getThousandSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
    this.decimalSepartor = AppUtils.getDecimalSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
  }

  ngOnInit() {
    // Combine them both into a single observable
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
      forkJoin(
        this.plantService.getShiftsBySiteId(this.siteId),
        this.siteService.getTreeConfiguration(this.siteId, ['treeData'])
      ).subscribe(([shifts, treeConfig]) => {
        this.shifts = shifts;
        this.dataSource.data = [];
        if (treeConfig !== undefined && treeConfig.treeData !== undefined) {
          // Data api is wrong. Can not use checkbox
          const dataPaser = JSON.parse(treeConfig.treeData);
          this.dataSource.data = this.buildFileTree(
            dataPaser[0],
            this.dataSource.data,
            null
          );
          this.tree.treeControl.expandAll();

          const firstLeftOfTree = this.getFirstLeafOfTree(this.dataSource.data);
          if (firstLeftOfTree !== undefined && firstLeftOfTree != null) {
            if (this.parentOfFirstLeaf && this.parentOfFirstLeaf !== null) {
              this.setCurrentNode(this.parentOfFirstLeaf);

              const node = document.getElementById(this.parentOfFirstLeaf.item);
              if (node && node != null) {
                node.dispatchEvent(new Event('click'));

                this.getDataAndDrawEnergyTrendsChart();
              }
            }
          }
        }
      });
    });
  }

  // tslint:disable-next-line:member-ordering
  @ViewChild('tree') tree;
  ngAfterViewInit(): void {
    this.tree.treeControl.expandAll();
    // collapseAll
  }
  /* Begin Function on Tree*/
  getLevel = (node: FeatureItemFlatNode) => node.level;

  isExpandable = (node: FeatureItemFlatNode) => node.expandable;

  getChildren = (node: FeatureItemNode): FeatureItemNode[] => node.nodes;

  hasChild = (_: number, _nodeData: FeatureItemFlatNode) =>
    _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: FeatureItemFlatNode) =>
    _nodeData.item === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: FeatureItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.item === node.item
        ? existingNode
        : new FeatureItemFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.id = node.id;
    flatNode.nodes = node.nodes;
    flatNode.nodeType = node.nodeType;
    flatNode.processRId = node.processRId;
    flatNode.meterId = node.meterId;
    flatNode.loadId = node.loadId;
    flatNode.expandable = !!node.nodes;
    if (node.attributes) {
      const attribute = new AttributeClass();
      attribute.class = node.attributes.class;
      attribute.parentId = node.attributes.parentId;
      attribute.childClass = node.attributes.childClass;
      attribute.thisClass = node.attributes.thisClass;
      flatNode.attributes = attribute;
    }
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    if (node.selected) {
      this.checklistSelection.select(flatNode);
    }
    return flatNode;
  };
  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: FeatureItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    // const flag = descendants.some(child =>
    //   this.checklistSelection.isSelected(child)
    // );
    // return flag;
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    return descAllSelected;
  }
  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: FeatureItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the feature item selection. Select/deselect all the descendants node */
  featureItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.setCurrentNode(node);
    this.getDataAndDrawEnergyTrendsChart();
  }

  /** Toggle a leaf feature item selection. Check all the parents to see if they changed */
  featureLeafItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.setCurrentNode(node);
    this.getDataAndDrawEnergyTrendsChart();
  }
  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: FeatureItemFlatNode): void {
    let parent: FeatureItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }
  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: FeatureItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }
  /* Get the parent node of a node */
  getParentNode(node: FeatureItemFlatNode): FeatureItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  buildFileTree(
    obj: any,
    nodes: FeatureItemNode[],
    currentSelected: FeatureItemFlatNode
  ): FeatureItemNode[] {
    const node = new FeatureItemNode();
    node.item = obj.title;
    node.id = obj.id;
    node.nodeType = obj.nodeType;
    node.processRId = obj.processRId !== undefined ? obj.processRId : 'NA';
    node.meterId = obj.meterId !== undefined ? obj.meterId : 'NA';
    node.loadId = obj.loadId !== undefined ? obj.loadId : 'NA';
    // node.selected = obj.state.selected;
    if (currentSelected != null && currentSelected.id === obj.id) {
      node.selected = true;
    }
    if (obj.attributes) {
      const attribute = new AttributeClass();
      attribute.class = obj.attributes.class;
      attribute.parentId = obj.attributes.parentId;
      attribute.childClass = obj.attributes.childClass;
      attribute.thisClass = obj.attributes.thisClass;
      node.attributes = attribute;
    }
    if (obj.nodes.length > 0) {
      node.nodes = [];
      obj.nodes.forEach((element) => {
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      });
    }
    return nodes.concat(node);
  }
  public onCheckedNodeChange = (
    node: FeatureItemFlatNode,
    hasChild: boolean
  ): boolean => {
    const isSelected = this.checklistSelection.isSelected(node);
    this.checklistSelection.deselect(...this.treeControl.dataNodes);
    if (isSelected) {
      this.checklistSelection.deselect(node);
    } else {
      this.checklistSelection.select(node);
    }
    // hasChild ? this.onSelectedParent(node) : this.onSelectedLastChild(node);

    return isSelected;
  };
  /*End Function On tree*/
  chosenStartDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.year(normalizedYear.year());
    this.startDate.setValue(Moment$(ctrlValue).startOf('year'));
    // this.startDate.setValue(ctrlValue);
    datepicker.close();
  }
  chosenStartDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDate.setValue(Moment$(ctrlValue).startOf('month'));
    datepicker.close();
  }
  chosenEndDate_YearHandler(
    normalizedYear: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.year(normalizedYear.year());
    this.endDate.setValue(Moment$(ctrlValue).startOf('year'));
    datepicker.close();
  }
  chosenEndDate_MonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.endDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.endDate.setValue(Moment$(ctrlValue).startOf('month'));
    datepicker.close();
  }

  public onTimeBaseChange = () => {
    switch (this.timebase) {
      case 'Y': {
        this.startView = 'multi-year';
        this.minView = 'year';
        this.startDate = new FormControl(Moment$().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'M': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new FormControl(Moment$().startOf('month'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'Q': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new FormControl(Moment$().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
      }
      case 'W': {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new FormControl(Moment$().startOf('month'));
        this.hourWiseDataRequired = false;
        break;
      }
      default: {
        this.startView = 'month';
        this.minView = 'day';
        this.startDate = new FormControl(Moment$().subtract(3, 'days'));
        this.hourWiseDataRequired = true;
        break;
      }
    }
    this.endDate = new FormControl(Moment$());
  };

  public onGenerate = () => {
    this.getDataAndDrawEnergyTrendsChart();
  };

  public onBack = () => {
    // this.router.navigate(['site/energy-dashboard', 'energy'], { queryParams: {siteId: this.siteId, activedTab: 1} });
    this.dialogRef.close({ status: confirm, data: false });
  };

  transformDate(date: FormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, Constants.DATE.DATE_FORMAT);
    } else {
      return '';
    }
  }

  private getDataAndDrawEnergyTrendsChart = () => {
    const fromDate = this.transformDate(this.startDate);
    const toDate = this.transformDate(this.endDate);
    const t = this;
    setTimeout(() => {
      t.energyService
        .getEnergyTrendsData(
          t.siteId,
          fromDate,
          toDate,
          t.timebase,
          t.currentNode.meterIds,
          t.enableShiftwise,
          t.currentNode.nodeType,
          t.showidleEnergy
        )
        .subscribe((data) => {
          t.drawEnergyTrendsChart(data);
        });
    }, 600);
  };

  private drawEnergyTrendsChart = (data: any) => {
    const option = this.getChartOption(this.currentNode.nodeTitle);
    const shiftcategories = [];
    const categories = [];
    const series = [];
    const loads = data.loads;
    const nodeMeterIdsArr = [];
    const allMeters = this.getAllMetersIdOfNode(this.currentNode.nodeData, []);
    const uniqueArray = AppUtils.uniqueArray(allMeters);
    nodeMeterIdsArr.push(uniqueArray);
    const show = false;
    const ecOfLoadsOnDate = data.ecOfLoadsOnDate;
    const allShiftDataArrays = [];
    const alltaskDataArrays = [
      [1, 'utilization'],
      [2, 'idle']
    ];
    for (let sn = 0; sn < this.shifts.length; sn++) {
      const shiftDataArray = [
        this.shifts[sn].shiftId,
        this.shifts[sn].shiftName
      ];
      allShiftDataArrays.push(shiftDataArray);
    }
    const allDayDataArrays = [];
    for (let sm = 0; sm < ecOfLoadsOnDate.length; sm++) {
      const dateArray = [ecOfLoadsOnDate[sm].xAxis];
      allDayDataArrays.push(dateArray);
    }
    for (let i = 0; i < ecOfLoadsOnDate.length; i++) {
      const date = ecOfLoadsOnDate[i].xAxis;
      if (this.enableShiftwise === true) {
        shiftcategories.push(date);
        for (let s = 0; s < this.shifts.length; s++) {
          const dataArr = [];
          let sumEC = 0;
          for (let j = 0; j < nodeMeterIdsArr.length; j++) {
            const nodeMeterIds = nodeMeterIdsArr[j];
            sumEC = 0;
            for (let t = 0; t < nodeMeterIds.length; t++) {
              let found = false;
              for (let k = 0; k < ecOfLoadsOnDate[i].valueArr.length; k++) {
                const item = ecOfLoadsOnDate[i].valueArr[k];
                // tslint:disable-next-line:triple-equals
                if (nodeMeterIds[t] == item.meterid) {
                  sumEC += item[Constants.SHIFTS[s]];
                  found = true;
                  break;
                }
              }
            }
            dataArr.push(sumEC);
          }
          for (let ar = 0; ar < allShiftDataArrays.length; ar++) {
            if (this.shifts[s].shiftId === allShiftDataArrays[ar][0]) {
              allShiftDataArrays[ar].push(sumEC);
            }
          }
        }
        option.legend.title.text = ':: Drag me';
        option.tooltip = {
          formatter: function () {
            return (
              '<span><b>' +
              this.point.category +
              '</b></span><br/><span style="color:' +
              this.series.points[this.point.index].color +
              '">  ' +
              this.series.name +
              '</span>: <b>' +
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+this.point.y) +
              '</b><br/><span>Total: <b>' +
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+this.point.stackTotal) +
              '</b></span>'
            );
          }
        };
        option.xAxis[0].categories = shiftcategories;
      } else if (this.showidleEnergy === true) {
        shiftcategories.push(date);
        for (let s = 0; s < 2; s++) {
          const dataArr = [];
          let sumEC = 0;
          for (let j = 0; j < nodeMeterIdsArr.length; j++) {
            const nodeMeterIds = nodeMeterIdsArr[j];
            sumEC = 0;
            for (let t = 0; t < nodeMeterIds.length; t++) {
              let found = false;
              for (let k = 0; k < ecOfLoadsOnDate[i].valueArr.length; k++) {
                const item = ecOfLoadsOnDate[i].valueArr[k];
                // tslint:disable-next-line:triple-equals
                if (nodeMeterIds[t] == item.meterid) {
                  sumEC += item[Constants.IDLE_UTILIZATION[s]];
                  found = true;
                  break;
                }
              }
            }
            dataArr.push(sumEC);
          }
          for (let ar = 0; ar < 2; ar++) {
            if (Constants.IDLE_UTILIZATION[s] === alltaskDataArrays[ar][1]) {
              alltaskDataArrays[ar].push(sumEC);
            }
          }
        }
        option.legend.title.text = ':: Drag me';
        option.tooltip = {
          formatter: function () {
            return (
              '<span><b>' +
              this.point.category +
              '</b></span><br/><span style="color:' +
              this.series.points[this.point.index].color +
              '">' +
              this.series.name +
              '</span>: <b>' +
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+this.point.y) +
              ' kWh</b><br/><span>Total: <b>' +
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+this.point.stackTotal) +
              '</b></span>'
            );
          }
        };
        option.xAxis[0].categories = shiftcategories;
      } else {
        const dataArr = [];
        categories.push(date);
        let sumEC1 = 0;
        for (let j = 0; j < nodeMeterIdsArr.length; j++) {
          const nodeMeterIds = nodeMeterIdsArr[j];
          sumEC1 = 0;
          for (let t = 0; t < nodeMeterIds.length; t++) {
            let found = false;
            for (let k = 0; k < ecOfLoadsOnDate[i].valueArr.length; k++) {
              const item = ecOfLoadsOnDate[i].valueArr[k];
              // tslint:disable-next-line:triple-equals
              if (nodeMeterIds[t] == item.meterid) {
                sumEC1 += item.sum;
                found = true;
                break;
              }
            }
          }
          dataArr.push(sumEC1);
        }
        for (let ard = 0; ard < allDayDataArrays.length; ard++) {
          if (date === allDayDataArrays[ard][0]) {
            allDayDataArrays[ard].push(sumEC1);
          }
        }
        option.tooltip = {
          formatter: function () {
            return (
              '<span><b>' +
              this.point.category +
              '</b></span><br/><span style="color:' +
              this.series.points[this.point.index].color +
              '">   ' +
              this.series.name +
              '</span>: <b>' +
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+this.point.y) +
              ' kWh</b>'
            );
          }
        };
        option.xAxis[0].categories = categories;
      }
    }
    if (this.enableShiftwise === true) {
      for (let sr = 0; sr < allShiftDataArrays.length; sr++) {
        const name = allShiftDataArrays[sr].splice(0, 2)[1];
        series.push({
          name: name,
          data: allShiftDataArrays[sr]
        });
      }
    } else if (this.showidleEnergy === true) {
      for (let sr = 0; sr < alltaskDataArrays.length; sr++) {
        const name = alltaskDataArrays[sr].splice(0, 2)[1];
        series.push({
          name: name,
          data: alltaskDataArrays[sr]
        });
      }
    } else {
      for (let sre = 0; sre < allDayDataArrays.length; sre++) {
        const srname = allDayDataArrays[sre].splice(0, 1)[0];
      }
      series.push({
        // 	name : srname,
        data: allDayDataArrays,
        showInLegend: false
      });
    }
    option.series = series;
    this.utilitiesService.enableDraggingHighChart();
    this.columnchart = new Chart(<any>option);
  };
  private getChartOption = (processName: string) => {
    const self = this;
    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    const option = {
      chart: {
        type: 'column',
        height: 585
      },
      credits: {
        enabled: false
      },
      title: {
        text:
          'Energy Consumption Trends - Process Level View' +
          (processName === undefined ? '' : ' for ' + processName)
      },
      xAxis: [
        {
          categories: [],
          crosshair: true
        }
      ],
      yAxis: {
        title: {
          text: 'Total Energy Consumption (kWh->)'
        },
        reversedStacks: false,
        labels: {
          formatter: function () {
            return new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')]
            ).format(+this.value);
          },
          style: {
            color: 'gray',
            fontWeight: 'bold'
          }
        }
      },
      tooltip: {},
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 120,
        verticalAlign: 'top',
        y: 100,
        title: {
          text: ''
        },
        borderWidth: 1,
        borderRadius: 5,
        floating: true,
        draggable: true,
        backgroundColor: '#FFFFFF'
      },
      plotOptions: {
        column: {
          stacking:
            this.enableShiftwise === true || this.showidleEnergy == true
              ? 'normal'
              : '',
          dataLabels: {
            enabled: true,
            formatter: function () {
              return new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+this.y);
            }
          }
        }
      },
      series: [{}]
    };
    return option;
  };

  private getAllMetersIdOfNode = (node: any, meterIds: any) => {
    if (node && node != null) {
      if (node.meterId !== 'NA') {
        meterIds.push(node.meterId);
      }
      if (node.nodes !== undefined && node.nodes.length > 0) {
        for (let i = 0; i < node.nodes.length; i++) {
          meterIds = this.getAllMetersIdOfNode(node.nodes[i], meterIds);
        }
      }
    }
    return meterIds;
  };

  private getFirstProcessOfTree = (tree: any) => {
    let result;
    if (tree && tree != null) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].processRId !== 'NA') {
          result = tree[i];
          break;
        } else {
          return this.getFirstProcessOfTree(tree[i].nodes);
        }
      }
    }
    return result;
  };

  private getFirstLeafOfTree = (tree: any, conditions: any = undefined) => {
    let result;
    if (tree !== undefined) {
      for (let i = 0; i < tree.length; i++) {
        if (this.hasChildNode(tree[i])) {
          this.parentOfFirstLeaf = tree[i];
          result = this.getFirstLeafOfTree(tree[i].nodes, conditions);
        } else {
          let conditionEvaluated = true;
          if (conditions !== undefined) {
            const propNames = Object.keys(conditions);
            for (let j = 0; j < propNames.length; j++) {
              conditionEvaluated =
                conditionEvaluated &&
                tree[i][propNames[j]] === conditions[propNames[j]];
              if (conditionEvaluated === false) {
                break;
              }
            }
          }
          if (tree[i].loadId !== undefined && conditionEvaluated) {
            result = tree[i];
            tree[i].selected = true;
            break;
          } else {
            continue;
          }
        }
        if (result !== undefined) {
          break;
        }
      }
    }
    return result;
  };

  private hasChildNode = (branch: any): boolean => {
    return branch.nodes === undefined || branch.nodes.length === 0
      ? false
      : true;
  };

  private setCurrentNode = (node: FeatureItemNode | FeatureItemFlatNode) => {
    if (node && node !== null) {
      this.currentNode.nodeData = node;
      const meterIds = this.getAllMetersIdOfNode(node, []);
      this.currentNode.meterIds = AppUtils.uniqueArray(meterIds);
      this.currentNode.nodeTitle = node.item;
      this.currentNode.nodeType = node.nodeType;
    }
  };

  validateStartDate() {
    this.isValidEndDate = true;
    this.endDate.setErrors(null);
    if (!this.startDate.invalid) {
      const fromDate = new Date(this.transformDate(this.startDate));
      const toDate = new Date(this.transformDate(this.endDate));

      if (fromDate > toDate) {
        this.isValidStartDate = false;
        this.startDateErrorMessage =
          'End date must be equal or greater than start date.';
        this.startDate.setErrors({ invalidDate: true });
        return;
      }

      if (this.timebase === 'D') {
        var one_day = 1000 * 60 * 60 * 24;
        if (
          Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >= 31
        ) {
          this.isValidStartDate = false;
          this.startDateErrorMessage =
            'Greater than 31 days is not allowed for Timebase: Daily.';
          this.startDate.setErrors({ invalidDate: true });
          return;
        }
      }

      this.isValidStartDate = true;
      this.isValidEndDate = true;
      const error = this.startDate.getError('invalidDate');
      if (error) {
        this.startDate.setErrors(null);
      }
    } else {
      this.startDateErrorMessage = 'Invalid date.';
    }
  }

  validateEndDate() {
    this.isValidEndDate = true;
    this.isValidStartDate = true;
    this.startDate.setErrors(null);
    if (!this.endDate.invalid) {
      const fromDate = new Date(this.transformDate(this.startDate));
      const toDate = new Date(this.transformDate(this.endDate));

      if (fromDate > toDate) {
        this.isValidEndDate = false;
        this.endDateErrorMessage =
          'End date must be equal or greater than start date.';
        this.endDate.setErrors({ invalidDate: true });
        return;
      }

      if (this.timebase === 'D') {
        var one_day = 1000 * 60 * 60 * 24;
        if (
          Math.round((toDate.getTime() - fromDate.getTime()) / one_day) >= 31
        ) {
          this.isValidEndDate = false;
          this.endDateErrorMessage =
            'Greater than 31 days is not allowed for Timebase: Daily.';
          this.endDate.setErrors({ invalidDate: true });
          return;
        }
      }

      this.isValidEndDate = true;
      this.isValidStartDate = true;
      const error = this.endDate.getError('invalidDate');
      if (error) {
        this.endDate.setErrors(null);
      }
    } else {
      this.endDateErrorMessage = 'Invalid date.';
    }
  }
}
